const pageConstants = {
  products: { base: "products", fullUrl: "/dashboard/products" },
  app: { base: "app", fullUrl: "/dashboard/app" },
  category: { base: "categories", fullUrl: "/dashboard/categories" },
  links: { base: "links", fullUrl: "/dashboard/links" },
};

export default pageConstants;
